<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";

  .selector-dropdown {
    display: flex;
    width: utils.in_rem(174px);
  }
</style>

<script>
  // Components
  import Dropdown from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/Dropdown.svelte";
  import ListItem from "@sourcewhale/shared/svelte-design-system/components/molecules/Dropdown/ListItem.svelte";

  export let items = [];
  export let selectedItem = {};
  export let displayText = "Select item";
  export let size = "large";
  export let selectorStyle = "";

  let closeDropdown;
</script>

<div class="selector-dropdown" style={selectorStyle}>
  <Dropdown class="flex-1" kind="input-field" {size} bind:close={closeDropdown}>
    <span slot="button">{selectedItem.text || displayText}</span>
    {#each items as item}
      <ListItem
        onclick={() => {
          selectedItem = item;
          closeDropdown();
        }}
      >
        {item.text}
      </ListItem>
    {/each}
  </Dropdown>
</div>
